import React from 'react';
import Button from '../Button/Button';
import { useEscapeToClose } from '../../../hooks/useEscapeToClose';
import styles from './ImageSourcePickerModal.module.css';

export type ImageSourcePickerSource = 'camera' | 'gallery';

interface ImageSourcePickerModalProps {
  open: boolean;
  title?: string;
  galleryMultiple?: boolean;
  onFilesSelected: (files: File[], source: ImageSourcePickerSource) => void;
  onCancel: () => void;
}

const readSelectedFiles = (event: React.ChangeEvent<HTMLInputElement>): File[] => {
  const files = Array.from(event.target.files ?? []);
  event.target.value = '';
  return files;
};

const ImageSourcePickerModal: React.FC<ImageSourcePickerModalProps> = ({
  open,
  title = 'Adicionar foto',
  galleryMultiple = false,
  onFilesSelected,
  onCancel,
}) => {
  useEscapeToClose(onCancel, open);

  if (!open) {
    return null;
  }

  return (
    <div className={styles.overlay} role="presentation" onClick={onCancel}>
      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="image-source-picker-title"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="image-source-picker-title" className={styles.title}>{title}</h2>
        <p className={styles.hint}>Escolha como deseja adicionar a imagem.</p>

        <div className={styles.actions}>
          <div className={styles.nativeAction}>
            <Button
              type="button"
              variant="primary"
              size="medium"
              fullWidth
              icon="photo_camera"
              tabIndex={-1}
              aria-hidden
            >
              Tirar foto
            </Button>
            <input
              type="file"
              accept="image/*"
              capture="environment"
              className={styles.nativeFileInput}
              aria-label="Tirar foto"
              onChange={(event) => {
                const files = readSelectedFiles(event);
                if (files.length > 0) {
                  onFilesSelected(files, 'camera');
                }
              }}
            />
          </div>

          <div className={styles.nativeAction}>
            <Button
              type="button"
              variant="outline"
              size="medium"
              fullWidth
              icon="image"
              tabIndex={-1}
              aria-hidden
            >
              Escolher da galeria
            </Button>
            <input
              type="file"
              accept="image/*"
              multiple={galleryMultiple}
              className={styles.nativeFileInput}
              aria-label="Escolher da galeria"
              onChange={(event) => {
                const files = readSelectedFiles(event);
                if (files.length > 0) {
                  onFilesSelected(files, 'gallery');
                }
              }}
            />
          </div>

          <Button
            type="button"
            variant="ghost"
            size="medium"
            fullWidth
            onClick={onCancel}
          >
            Cancelar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ImageSourcePickerModal;
